import React, { useEffect, useState } from 'react';
import Menu from '../../../components/sturtural/Menu';
import { BASE_API } from '../../../api/Globals';
import { Navigate } from 'react-router-dom';
import { helpHttp } from '../../../helpers/helpHttp';
import RequestCard from '../../../components/demand/RequestCard';
import Loader from '../../../components/sturtural/Loader';
import MessageDetail from '../../../components/sturtural/MessageDetail';

import TawkMessengerReact from '../../../components/sturtural/Tawk';
import { storage } from '../../../helpers/storage';

const DemandList = () => {
    const [db, setDb] = useState(null); 
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [solicitudid, setSolicitudId] = useState(null);
    const [cedulaid, setCedulaId] = useState(null);

    let url = `${BASE_API}demand/recover/${storage.get('id')}`;//usuario

    useEffect(() => {
        setLoading(true);
        helpHttp().get(url).then(res => {
            if(!res.err) {
                setDb(res);
                setError(null);
            } else {
                setDb(null);
                setError(res);
            }
            setLoading(false); 
        });
    }, [url]);

    const handleDigitization = solicitudid => {
        window.localStorage.setItem('solicitudid', solicitudid);
        setSolicitudId(solicitudid);
    }

    const handleImpresion = (solicitudid) => {
        window.localStorage.setItem('solicitudid', solicitudid);
        setCedulaId(solicitudid);
    }

    return (
        <>
            <Menu link='lista-solicitudes' />
            
            {solicitudid && <Navigate to={'/digitalizacion'} />}
            {cedulaid && <Navigate to={'/cedula'} />}
            <MessageDetail color="warn" mensaje="LISTA DE SOLICITUDES DE CÉDULA PROFESIONAL ELECTRÓNICA" />
            <div className="grid">
                {loading && <div><Loader /></div> }
                {error && <MessageDetail color="error" mensaje={`Error ${error.status}: ${error.statusText}`} />}
                {db && <RequestCard data={db} handleDigitization={handleDigitization} handleImpresion={handleImpresion}/>}
            </div>
            <TawkMessengerReact />
        </>
    );
}

export default DemandList;